export const linkNameToModel = {
  facebookLink: 'Facebook',
  instagramLink: 'Instagram',
  twitterLink: 'Twitter',
  linkedinLink: 'LinkedIn',
  youtubeLink: 'Youtube',
  pinterestLink: 'Pinterest',
};
